import { Actions } from './pieceGestionActions';

import { dateToddmmyyy } from 'utils/stringHelper';

/**
 * Etat initial
 */
const initialState = {
    piecesGestion: {
        items: [],
        isLoading: false,
        afterSearch: false,
        criteres: {
            typeRecherche: 'piece',
            numeroPiece: '',
            referenceCommande: '',
            dateDebut: '',
            dateFin: '',
            codeArticle: ''
        }
    }
};

/**
 * Reducer pour les pièces gestion
 */
const reducer = (namespace) => (state = initialState, action) => {

    switch (action.type) {
        // Fetch Pieces gestion.
        case `${namespace}/${Actions.FETCH_PIECES_GESTION_REQUEST}`:
            return {
                ...state,
                piecesGestion: { ...state.piecesGestion, isLoading: true }
            };
        case `${namespace}/${Actions.FETCH_PIECES_GESTION_SUCCESS}`:
            return {
                ...state,
                piecesGestion: { ...state.piecesGestion, items: [...action.piecesGestion], isLoading: false, afterSearch: true }
            };
        case `${namespace}/${Actions.FETCH_PIECES_GESTION_FAILURE}`:
            return {
                ...state,
                piecesGestion: { ...state.piecesGestion, isLoading: false, error: action.error, afterSearch: true }
            };

        // Critères de recherche
        case `${namespace}/${Actions.UPDATE_SEARCH_PIECE_FILTERS}`:
            {
                return {
                    ...state,
                    piecesGestion: {
                        ...state.piecesGestion,
                        criteres: action.criteres,
                        afterSearch: false
                    }
                };
            }
        case `${namespace}/${Actions.CLEAR_SEARCH_PIECE_FILTERS}`:
            {
                var lastMonth = new Date();
                lastMonth.setMonth(lastMonth.getMonth() - 1);

                return {
                    ...state,
                    piecesGestion: {
                        ...state.piecesGestion,
                        items: [],
                        afterSearch: false,
                        criteres: { ...initialState.piecesGestion.criteres, dateDebut: dateToddmmyyy(lastMonth), dateFin: dateToddmmyyy(new Date()) }
                    }
                };
            }

        case `${namespace}/${Actions.CLEAR_PIECES_GESTION}`:
            {
                return {
                    ...state,
                    piecesGestion: {
                        ...state.piecesGestion,
                        items: [],
                        afterSearch: false
                    }
                };
            }

        default:
    }

    return state;
};

export default reducer;